/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaLineupCreate = {
    properties: {
        fantaLineupPositionPlayers: {
            type: 'array',
            contains: {
                type: 'FantaLineupPositionPlayerCreate',
            },
            isRequired: true,
        },
        fantaBenchPlayers: {
            type: 'array',
            contains: {
                type: 'FantaBenchPlayerCreate',
            },
            isRequired: true,
        },
    },
} as const;
